import React from 'react'
import { Button, Card, Col, Flex, Image, Row, Typography } from 'antd'
import { motion } from 'framer-motion'
import Slider from "react-slick";

const { Text, Title } = Typography
const LeadingCompanies = () => {

    const data = [
        {
            img:'verisk.webp'
        },
        {
            img:'costa.webp'
        },
        {
            img:'ingeus.webp'
        },
        {
            img:'maximus.webp'
        },
        {
            img:'elysium.png'
        },
        {
            img:'dxc.webp'
        },
    ]

    var testimonialSlider = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 0,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
            },
          },
        ],
      };

  return (
    <div className='padding-t-m bg-light m-top-130'>
        <div className='container'>
            <Row gutter={[24,24]} justify={'center'}>
                <Col lg={{span: 16}} md={{span: 18}} sm={{span: 24}} xs={{span: 24}} >
                    <Title level={1} className='m-0 gradient-text text-center'>
                        Find a job you'll love with the UK's #1 job site
                    </Title>
                </Col>
                <Col span={24}>
                    {/* <Row gutter={[16,16]}>
                        {
                            data?.map((brands,index)=>
                                <Col lg={{span: 8}} md={{span: 12}} sm={{span: 12}} xs={{span: 12}} key={index}>
                                    
                                </Col>
                            )
                        }
                    </Row> */}
                    <Slider {...testimonialSlider}>
                        {data?.map((brands, index) => {
                        return (
                            <div className="px-2" key={index}>
                                <Card className='card-cs'>
                                    <Image src={'/assets/images/'+brands?.img} preview={false} />
                                </Card> 
                            </div>
                        );
                        })}
                    </Slider>                       
                </Col>
                {/* <Col lg={{span: 10}} md={{span: 12}} sm={{span: 24}} xs={{span: 24}} >
                    <Flex vertical gap={20}>
                        <motion.div
                            initial={{ opacity: 0}}
                            whileInView={{
                                opacity: 1
                            }}
                            transition={{ duration: 2, ease: 'easeInOut' }}
                            viewport={{once: true}}
                        >
                            <Title level={1} className='m-0 brown-gadient'
                            >
                                Find a job you'll love with the UK's #1 job site
                            </Title>
                        </motion.div>
                        <motion.div
                            initial={{ y: 100, opacity: 0 }}
                            whileInView={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{ delay: .2, duration: 2, type:'spring', stiffness: 300 }}
                            viewport={{once: true}}
                        >
                            <Text className='text-gray fs-16'
                            >
                                Your next role could be with one of these leading companies.
                            </Text>
                        </motion.div>
                        <motion.Flex
                            initial={{ y: '100%', opacity: 0 }}
                            whileInView={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{ delay: .2, duration: 2, }}
                            viewport={{once: true}}
                        >
                            <Button className='btn w-auto'>
                                Seel all companies
                            </Button>
                        </motion.Flex>
                    </Flex>
                </Col> */}
            </Row>
        </div>
    </div>
  )
}

export {LeadingCompanies}